import { lazy } from "react";
import { Navigate } from "react-router-dom";
import WithSuspense from "../../components/Loaders/WithSuspense";
import { AppRoute } from "../types";
import { PRIVATE_PATHS } from "../constants";
import ContactDetail from "pages/CRM/Contacts/ContactDetails";
import DealDetails from "pages/CRM/Deals/DealDetails";
import CompanyDetails from "pages/CRM/Companies/CompanyDetails";
import CreateTask from "pages/CRM/Tasks/CreateTask";

const { CRM } = PRIVATE_PATHS;

const CrmDashboard = WithSuspense(lazy(() => import("../../pages/CRM/Dashboard/CrmDashboard")));
const Contacts = WithSuspense(lazy(() => import("../../pages/CRM/Contacts/Contacts")));
const Companies = WithSuspense(lazy(() => import("../../pages/CRM/Companies/Companies")));
const Deals = WithSuspense(lazy(() => import("../../pages/CRM/Deals/Deals")));
const Tasks = WithSuspense(lazy(() => import("../../pages/CRM/Tasks/Tasks")));
const Reports = WithSuspense(lazy(() => import("../../pages/CRM/Reports/Reports")));
const CreateContact = WithSuspense(lazy(() => import("../../pages/CRM/Contacts/CreateContact")));
const CreateDeal = WithSuspense(lazy(() => import("../../pages/CRM/Deals/CreateDeal")));
const CreateCompany = WithSuspense(lazy(() => import("../../pages/CRM/Companies/CreateCompany")));

const SettingsLayout = WithSuspense(lazy(() => import("../../pages/CRM/Settings/SettingsLayout")));
const Tags = WithSuspense(lazy(() => import("../../pages/CRM/Settings/Tabs/Tags")));
const CrmValues = WithSuspense(lazy(() => import("../../pages/CRM/Settings/Tabs/CrmValues")));
const Currency = WithSuspense(lazy(() => import("../../pages/CRM/Settings/Tabs/Currency")));

const CRM_ROLES = ["CRM_ADMIN", "CRM_MANAGER", "CRM_USER", "ORG_OWNER", "ORG_ADMIN"];

// Narrower than CRM_ROLES on purpose: configuring the module is an admin's
// job, the same way HRMS keeps its own settings to HRM Admin and above.
const CRM_SETTINGS_ROLES = ["ORG_OWNER", "ORG_ADMIN", "CRM_ADMIN"];

export const CRM_MODULE_ROUTES: AppRoute[] = [
  { path: CRM.DASHBOARD, element: <CrmDashboard />, roles: CRM_ROLES },
  { path: CRM.CONTACTS.VIEW_ALL, element: <Contacts />, roles: CRM_ROLES },
  // { path: CRM.CONTACTS.DETAILS, element: <Contacts />, roles: CRM_ROLES },
  { path: CRM.COMPANIES, element: <Companies />, roles: CRM_ROLES },
  { path: CRM.CREATE_COMPANY, element: <CreateCompany />, roles: CRM_ROLES },
  { path: CRM.DEALS, element: <Deals />, roles: CRM_ROLES },
  { path: CRM.CREATE_DEAL, element: <CreateDeal />, roles: CRM_ROLES },
  { path: CRM.DEAL_DETAILS, element: <DealDetails />, roles: CRM_ROLES },
  { path: CRM.TASKS, element: <Tasks />, roles: CRM_ROLES },
  { path: CRM.CREATE_TASK, element: <CreateTask />, roles: CRM_ROLES },
  { path: CRM.REPORTS, element: <Reports />, roles: CRM_ROLES },
  { path: "/:orgSlug/crm", element: <Navigate to="contacts" replace />, roles: CRM_ROLES },
  { path: CRM.CREATE_CONTACT, element: <CreateContact />, roles: CRM_ROLES },
  { path: CRM.CONTACT_DETAILS, element: <ContactDetail />, roles: CRM_ROLES },
  { path: CRM.COMPANY_DETAILS, element: <CompanyDetails />, roles: CRM_ROLES },
  {
    path: CRM.SETTINGS.MAIN,
    element: <SettingsLayout />,
    roles: CRM_SETTINGS_ROLES,
    children: [
      // Settings has no landing page of its own; the first screen is the page.
      { index: true, element: <Navigate to="tags" replace /> },
      { path: CRM.SETTINGS.TAGS, element: <Tags /> },
      { path: CRM.SETTINGS.VALUES, element: <CrmValues /> },
      { path: CRM.SETTINGS.CURRENCY, element: <Currency /> },
    ],
  },
];
